import format from 'date-fns/fp/format';

const DateFormatService = {
  formatDate: (date, formatPattern = 'dd.MM.yyyy') => format(formatPattern, date)
};

export default DateFormatService;
